import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  GalleryIcon,
  GalleryInfo,
  Info,
  InfoNumber,
  InfoWrapper
} from './Styles';
import MultiMediaButton from './MultiMediaButton';

const Gallery = ({ mediaList, tradeDetails, setOverlayOpen }) => {
  const count = mediaList?.meta?.count;

  return (
    <GalleryInfo className="vdpMultimedia-container">
      <InfoWrapper>
        <Info>
          <InfoNumber testId="photoGallery" variant="bold">
            {count?.photos} &nbsp;
            <GalleryIcon icon="TR5-Photo_camera" />
          </InfoNumber>
          {/* Overview */}
          <FormattedMessage id="vdp.overview.media.overview" />
        </Info>
        <Info>
          <InfoNumber testId="disclosureGallery" variant="bold">
            {count?.damages} &nbsp;
            <GalleryIcon icon="TR5-Photo_camera" />
          </InfoNumber>
          {/* Disclosure */}
          <FormattedMessage id="vdp.overview.media.disclosure" />
        </Info>
        <Info>
          <InfoNumber testId="videoGallery" variant="bold">
            {count?.videos} &nbsp;
            <GalleryIcon icon="TR5-Video_camera" />
          </InfoNumber>
          {/* Videos */}
          <FormattedMessage id="vdp.overview.media.videos" />
        </Info>
      </InfoWrapper>
      <MultiMediaButton
        mediaList={mediaList}
        tradeDetails={tradeDetails}
        setOverlayOpen={setOverlayOpen}
      />
    </GalleryInfo>
  );
};

export default Gallery;
